// extracted by mini-css-extract-plugin
export default {"layoutWrapperContainer":"layoutWrapper_layoutWrapperContainer__kPc4g","innerContainer":"layoutWrapper_innerContainer__s0fvo"};